<template>
  <header class="app-header" :class="{ 'app-header--always': alwaysVisible }">
    <button
      v-if="showBack"
      type="button"
      class="app-header-left"
      :aria-label="$t('common.back', 'Back')"
      @click="goBack"
    >
      <font-awesome-icon icon="chevron-left" />
    </button>
    <div v-else class="app-header-left"></div>
    <h1 class="app-header-title">{{ title }}</h1>
    <div class="app-header-right">
      <slot name="right"></slot>
    </div>
  </header>
</template>

<script>
import { useRouter } from "vue-router";

export default {
  name: "AppHeader",
  props: {
    title: {
      type: String,
      required: true,
    },
    showBack: {
      type: Boolean,
      default: false,
    },
    // By default the header only renders on mobile-width viewports. Surfaces
    // that need it at every width (the legal pages inside the native shell,
    // where it replaces the marketing topbar — including on tablets) set this.
    alwaysVisible: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const router = useRouter();

    const goBack = () => {
      router.back();
    };

    return { goBack };
  },
};
</script>

<style scoped>
.app-header {
  position: sticky;
  top: 0;
  z-index: 100;
  display: none;
  align-items: center;
  height: calc(56px + var(--safe-top, env(safe-area-inset-top, 0px)));
  padding-top: var(--safe-top, env(safe-area-inset-top, 0px));
  padding-left: 16px;
  padding-right: 16px;
  background: var(--al-surface-raised);
  border-bottom: 1px solid var(--al-border);
}

.app-header--always {
  display: flex;
}

@media (max-width: 768px) {
  .app-header {
    display: flex;
  }
}

.app-header-left {
  min-width: 44px;
  min-height: 44px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 18px;
  color: var(--al-text);
  background: none;
  border: none;
  padding: 0;
}

.app-header-title {
  flex: 1;
  font-size: 18px;
  font-weight: 600;
  color: var(--al-black);
  font-family: inherit;
  text-align: center;
  margin: 0;
}

.app-header-right {
  min-width: 44px;
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
}
</style>
